import React, { useState, createContext, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import useFetch, { reload } from "../../../shared/hooks/useFetch";
import {
  ACCESS_OBJECT,
  ACCESS_PERM,
  BUSINESS_LOAN_TABS,
  CREDITLINE_TABS,
  LOAN_TABS,
} from "../../../shared/utils/constants";
import GetAuthContext from "../../../shared/context/AuthContext";

interface IApplicationContext {
  loanID: string;
  applicationDetails: string;
  sourceEntityName: string;
  status: string;
  setStatus: Function;
  reloadApplicationData?: reload;
  isApplicationDetailsLoading: boolean;
  loanOffer: string;
  creditLineDetails: string;
  tabLabels: any[];
  sourceEntityID: string;
  reLoadLoanOffer?: reload;
}
const ApplicationContext = createContext<IApplicationContext | null>(null);

export const ApplicationProvider = ({ children }: any) => {
  const [tabLabels, setTabLabels] = useState<any[]>([]);
  const [status, setStatus] = useState("");

  const params = useParams();
  const loanID = params.loanID as string;
  const sourceEntityID = params?.sourceEntityID as string;
  const { canUser } = GetAuthContext();

  const {
    data: applicationData,
    reload: reloadApplicationData,
    isLoading: isApplicationDetailsLoading,
  } = useFetch<any>(
    `/masterDashboard/getLoanDetails?loanApplicationID=${loanID}`
  );

  const {
    data: loanOffer,
    isLoading: isLoanOfferLoading,
    reload: reLoadLoanOffer,
  } = useFetch<any>(
    `/masterDashboard/getLoanOffer?loanApplicationID=${loanID}`
  );

  const { data: creditLineDetails, isLoading: isCreditlineLoading } =
    useFetch<any>(
      `/masterDashboard/getCreditLineDetails?loanApplicationID=${loanID}`
    );

  const { data: getWorkflowsResponse } = useFetch<any>(
    `/masterDashboard/getWorkflows?loanApplicationID=${loanID}`
  );

  useEffect(() => {
    if (applicationData) {
      setStatus(applicationData.status);
      ["credit_line", "overdraft"].includes(applicationData.loanType)
        ? setTabLabels(CREDITLINE_TABS)
        : setTabLabels(LOAN_TABS);
      if (applicationData.loanType !== "personal_loan") {
        setTabLabels((tabs: any[]) => [...tabs, ...BUSINESS_LOAN_TABS]);
      }
      if (applicationData?.sourceEntityName === "Khatabook") {
        setTabLabels((tabs: any[]) => [
          ...tabs,
          {
            name: "UNDERWRITING",
          },
        ]);
      }

      if (!canUser(ACCESS_PERM.LIST, ACCESS_OBJECT.APPLICATIONS))
        setTabLabels((tabs) => tabs.filter((t) => t.name !== "KYC"));
      //   retriggerList["list"].find((id) => id == loanId) && pollUserData();
    }
  }, [applicationData]);

  return (
    <ApplicationContext.Provider
      value={{
        loanID: loanID,
        applicationDetails: applicationData,
        sourceEntityName: applicationData?.sourceEntityName,
        status,
        setStatus,
        reloadApplicationData,
        isApplicationDetailsLoading:
          isApplicationDetailsLoading ||
          isCreditlineLoading ||
          isLoanOfferLoading,
        loanOffer,
        creditLineDetails,
        tabLabels,
        sourceEntityID,
        reLoadLoanOffer,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

const GetApplicationContext = () => {
  const context = useContext(ApplicationContext);
  if (context === undefined) throw new Error("Context is not defined");
  return context;
};

export default GetApplicationContext;
